import React from "react";
import Select from "react-select";

import Yasgui from "@triply/yasgui";
import "@triply/yasgui/build/yasgui.min.css";

import BNF_PREFIXES from "./bnf-prefixes.js";

const DATABNF_ENDPOINT = "https://data.bnf.fr/sparql";
const QUERIES_URI = process.env.PUBLIC_URL + "/sample-queries.json";

const Yasqe = Yasgui.Yasqe;

Yasqe.defaults.autocompleters.splice(
  Yasqe.defaults.autocompleters.indexOf("prefixes"),
  1
);
Yasqe.forkAutocompleter("prefixes", {
  name: "prefixes-bnf",
  get: () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(
          Object.keys(BNF_PREFIXES).map(
            (prefix) => `${prefix}: <${BNF_PREFIXES[prefix]}>`
          ),
          20
        );
      });
    });
  },
});

Yasqe.defaults.value = `SELECT DISTINCT ?Concept
WHERE {
  [] a ?Concept
} LIMIT 100`;
Yasgui.defaults.requestConfig.endpoint = DATABNF_ENDPOINT;
Yasgui.defaults.endpointCatalogueOptions.getData = () => {
  return [
    {
      endpoint: DATABNF_ENDPOINT,
    },
    {
      endpoint: "https://dbpedia.org/sparql",
    },
    {
      endpoint: "https://query.wikidata.org",
    },
  ];
};

export default function Main() {
  const [bnfPrefixes, setBnfPrefixes] = React.useState([]);
  const [sampleQueries, setSampleQueries] = React.useState([]);
  const [yasgui, setYasgui] = React.useState();

  React.useEffect(() => {
    setYasgui(new Yasgui(document.getElementById("yasgui")));
    fetch(QUERIES_URI)
      .then((response) => response.json())
      .then((queries) =>
        setSampleQueries(
          queries.map((query, index) => {
            return {
              value: index,
              label: query.title,
              query: query.query,
            };
          })
        )
      );

    setBnfPrefixes(
      Object.keys(BNF_PREFIXES).map((prefix) => {
        return {
          value: prefix,
          label: `${prefix}: ${BNF_PREFIXES[prefix]}`,
        };
      })
    );
  }, []);

  const updateSampleQuery = (option) => {
    yasgui.getTab().setQuery(sampleQueries[option.value].query);
  };

  const addNewPrefix = (option) => {
    const prefixes = {};
    prefixes[option.value] = BNF_PREFIXES[option.value];
    yasgui.getTab().yasqe.addPrefixes(prefixes);
  };

  return (
    <main>
      <div className="selectors">
        <Select
          className="selector"
          onChange={updateSampleQuery}
          options={sampleQueries}
          placeholder="Exemple de requêtes"
          isSearchable
        />
        <Select
          className="selector"
          onChange={addNewPrefix}
          options={bnfPrefixes}
          placeholder="Espace de nom (namespace)"
          isSearchable
        />
      </div>
      <div>
        <div id="yasgui" />
      </div>
      <ResultsPermalink yasqe={yasgui ? yasgui.getTab().yasqe : null} />
    </main>
  );
}

const ResultsPermalink: React.FC = ({ yasqe }) => {
  const [query, setQuery] = React.useState("");
  const [endPointUrl, setEndPointUrl] = React.useState("");
  const [contentType, setContentType] = React.useState("");
  const contentTypeMapping = {
    "application/sparql-results+json": "application/json",
  }; // this will allow to render the result directly in the webbrowser

  React.useEffect(() => {
    if (!yasqe) {
      return;
    }
    yasqe.on(
      "queryResponse",
      (
        instance: Yasqe,
        req: superagent.SuperAgentRequest,
        duration: number
      ) => {
        setQuery(
          encodeURI(instance.getValueWithoutComments()).replace(/#/g, "%23")
        );
        setEndPointUrl(req.req.url);
        const contentType = req.header["content-type"];
        if (contentType in contentTypeMapping) {
          setContentType(contentTypeMapping[contentType]);
        } else {
          setContentType(contentType);
        }
      }
    );
  }, [yasqe, contentTypeMapping]);

  const resultsUrl = `${endPointUrl}?query=${query}&format=${contentType}`;
  return query ? (
    <div className="permalink">
      <a href={resultsUrl}>Permalien vers les résultats</a>
    </div>
  ) : null;
};
